var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.styles.subitems_container, { [_vm.styles.scrollable]: _vm.scrollable, [_vm.styles.grow]: _vm.grow }]},[_c('div',{ref:"subitems",class:_vm.styles.subitems,on:{"scroll":_vm.handleScroll}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }